module.exports = __webpack_public_path__ + "static/media/s7logo_white.3135554d.png";